import { SVGProps } from 'react';

export default function SearchNoDataIcon(props: SVGProps<SVGSVGElement>) {
  const { fill } = props;

  return (

    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path d="M1.83398 7.99992C1.83398 4.31802 4.81875 1.33325 8.50065 1.33325C12.1825 1.33325 15.1673 4.31802 15.1673 7.99992C15.1673 11.6818 12.1825 14.6666 8.50065 14.6666C4.81875 14.6666 1.83398 11.6818 1.83398 7.99992ZM8.50065 3.99992C8.86884 3.99992 9.16732 4.2984 9.16732 4.66658V7.72378L10.9721 9.52851C11.2324 9.78886 11.2324 10.211 10.9721 10.4713C10.7117 10.7317 10.2896 10.7317 10.0292 10.4713L8.02925 8.47132C7.90422 8.3463 7.83398 8.17673 7.83398 7.99992V4.66658C7.83398 4.2984 8.13246 3.99992 8.50065 3.99992Z" fill="#ADADAD" />
      <path d="M8.50065 4C8.86884 4 9.16732 4.29848 9.16732 4.66667V7.72386L10.9721 9.5286C11.2324 9.78895 11.2324 10.2111 10.9721 10.4714C10.7117 10.7318 10.2896 10.7318 10.0292 10.4714L8.02925 8.4714C7.90422 8.34638 7.83398 8.17681 7.83398 8V4.66667C7.83398 4.29848 8.13246 4 8.50065 4Z" fill={fill ?? 'white'} />
    </svg>
  );
}
